<template>
  <div class="bg-header h-80 w-full">
    <nav class="fixed bg-header top-0 left-0 w-full z-50 h-32">
      <div class="px-7 py-4 gradient-malut">
        <!-- navbar desktop -->
        <nav class="hidden min-[1161px]:flex min-[1161px]:justify-between min-[1161px]:items-center">
          <div class="z-0 -left-12 -top-12 shadow-shadow-circle box-content h-40 w-40 rounded-full bg-white absolute" />
          <router-link :to="{ name: 'landingpage' }">
            <div class="">
              <img v-img="'logo'" class="z-50 relative h-16 cursor-pointer mr-2"
                :src="`${$baseUrl}/logo/${informasiDasar?.logo}`" alt="logo" />
            </div>
          </router-link>
          <div class="space-x-7 text-biru">
            <a v-for="(menu, idx) in links">
              <router-link v-if="!Array.isArray(menu.link)" :to="{ name: menu.link }"> {{ $t(menu.name) }}</router-link>
              <a v-else @click="showDropdown(idx)" class="relative">
                <span class="cursor-pointer">{{ $t(menu.name) }}</span>
                <div class="delay-400 duration-200 ease-in-out left-0 bg-white rounded-md shadow-tabungan w-56 absolute"
                  :class="dropdownNum === idx && dropdownStat ? '  top-auto  z-10' : 'hidden  top-10'">
                  <div class="w-full cursor-pointer p-2 text-biru hover:bg-birulangitmaluku hover:text-blue-maluku hover"
                    v-for="sub in menu.link">
                    <router-link :to="{ name: sub.link }" class="w-full inline-block"> {{ $t(sub.name) }}</router-link>
                  </div>
                </div>
              </a>
            </a>
          </div>
          <div class="flex items-center space-x-2">
            <div class="space-x-2">
              <button :class="locale == 'en' ? 'font-semibold text-blue-maluku' : ''" @click="changeLocale('en')"
                class="text-ungusoft">En</button>
              <span class="text-ungusoft">|</span>
              <button :class="locale == 'id' ? 'font-semibold text-blue-maluku' : ''" @click="changeLocale('id')"
                class="text-ungusoft">ID</button>
            </div>
            <button
              class="hover:bg-ungu duration-500 bg-blue-maluku text-white rounded-lg pt-2 pb-2 pl-6 pr-6 text-sm text-center"
              type="button">
              {{ $t("message.hubungi_kami") }}
            </button>
          </div>
        </nav>
      </div>
      <!-- BUTTON LANGUAGE MOBILE VIEW -->
      <div class="flex justify-between md:hidden">
        <div class="">
          <div class="-left-12 -top-12 shadow-shadow-circle box-content h-40 w-40 rounded-full bg-white absolute" />
          <router-link :to="{ name: 'landingpage' }">
            <div class="">
              <img v-img="'logo'" class="z-50 relative h-16 cursor-pointer ml-5 -mt-2"
                :src="`${$baseUrl}/logo/${informasiDasar?.logo}`" alt="logo" />
            </div>
          </router-link>
          <!-- <router-link :to="{ name: 'landingpage' }">
            <img v-img="'logo'" class="h-16 cursor-pointer mr-2" :src="`${$baseUrl}/logo/${informasiDasar?.logo}`" alt="logo" />
          </router-link> -->
        </div>
        <div class="z-50 flex items-center mr-3">
          <div class="space-x-2 pr-3">
            <button :class="locale == 'en' ? 'font-semibold text-blue-maluku' : ''" @click="changeLocale('en')"
              class="text-ungusoft">En</button>
            <span class="text-ungusoft">|</span>
            <button :class="locale == 'id' ? 'font-semibold text-blue-maluku' : ''" @click="changeLocale('id')"
              class="text-ungusoft">ID</button>
          </div>
          <button @click="() => (showMobileMenu = !showMobileMenu)">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="30" height="30">
              <path fill="none" d="M0 0h24v24H0z" />
              <path d="M3 4h18v2H3V4zm0 7h18v2H3v-2zm0 7h18v2H3v-2z" fill="rgba(33, 64, 154, 1)" />
            </svg>
          </button>
        </div>
      </div>
      <!-- MENU MOBILE -->
      <div class="z-50 w-full absolute lg:hidden mt-10" :class="{ hidden: showMobileMenu }">
        <div class="absolute w-full grid bg-header shadow-tabungan h-auto text-biru p-8">
          <div v-for="(menu, idx) in links">
            <router-link v-if="!Array.isArray(menu.link)" :to="{ name: menu.link }"
              class="w-full inline-block cursor-pointer p-2 text-biru hover:bg-birulangitmaluku hover:text-blue-maluku hover:rounded-md">
              {{ $t(menu.name) }}</router-link>
            <div v-else @click="showDropdown(idx)" class="relative">
              <div
                class="flex items-center justify-center cursor-pointer hover:bg-birulangitmaluku hover:text-blue-maluku hover:rounded-md">
                <span class="w-full inline-block p-2 text-biru">{{ $t(menu.name) }}</span>
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                  stroke="currentColor" class="w-6 h-6">
                  <path v-if="dropdownNum === idx && dropdownStat" stroke-linecap="round" stroke-linejoin="round"
                    d="M4.5 15.75l7.5-7.5 7.5 7.5" />
                  <path v-else stroke-linecap="round" stroke-linejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
                </svg>
              </div>
              <div class="delay-400 duration-200 ease-in-out pl-4"
                :class="dropdownNum === idx && dropdownStat ? ' rounded-md w-full z-10 shadow-tabungan' : ' hidden'">
                <div class="w-full cursor-pointer p-2 text-biru hover:bg-birulangitmaluku hover:text-blue-maluku hover"
                  v-for="sub in menu.link">
                  <router-link :to="{ name: sub.link }" class="w-full inline-block"> {{ $t(sub.name) }}</router-link>
                </div>
              </div>
            </div>
          </div>
          <button type="button"
            class="py-2 px-5 font-medium text-biru focus:outline-none bg-white rounded-lg border border-gray-200 hover:bg-biru hover:text-white focus:z-10 focus:ring-4 focus:ring-biru">{{
              $t("message.hubungi_kami")
            }}</button>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
import { ref } from "vue";
import { useI18n } from "vue-i18n";
export default {
  props: ['informasiDasar'],
  setup() {
    const { locale } = useI18n();
    const showMobileMenu = ref(true);
    const dropdownNum = ref(0);
    const dropdownStat = ref(false);
    const links = ref([
      { name: "message.beranda", link: "landingpage" },
      {
        name: "message.informasi",
        link: [
          { name: "message.berita", link: "landingpageberita" },
          { name: "message.tender", link: "landingpagetender" },
        ],
      },
      {
        name: "message.produk",
        link: [
          { name: "message.simpanan", link: "landingpagebisnis" },
          { name: "message.sukubunga", link: "landingpagesukubunga" },
          { name: "message.pinjaman", link: "landingpagpinjaman" },
          { name: "message.layanan", link: "landingpaglayanan" },
        ],
      },
      {
        name: "message.perusahaan",
        link: [
          { name: "message.tentang1", link: "tentang-perusahaan" },
          { name: "message.csr", link: "csr-perusahaan" },
          { name: "message.investor", link: "investor-perusahaan" },
          { name: "message.tatakelola", link: "tata-kelola-perusahaan" },
          { name: "message.penghargaan", link: "landingpagepenghargaan" },
        ],
      },
      { name: "message.ebanking", link: "landingpageebanking" },
      { name: "message.simulasi", link: "simulasi" },
      { name: "message.jaringan_kantor", link: "landingpagjaringankantor" },
      { name: "message.karir", link: "landingpagekarir" },
    ]);

    const changeLocale = (lang) => {
      locale.value = lang;
    };

    const showDropdown = (x) => {
      if (x === dropdownNum.value || dropdownNum.value === 0 || dropdownStat.value === false) dropdownStat.value = !dropdownStat.value;
      dropdownNum.value = x;
    };

    return { links, showDropdown, dropdownStat, dropdownNum, showMobileMenu, changeLocale, locale };
  },
};
</script>
